import BitesApi from '../index';

interface IAnalyticsRequestData {
  orgId: number;
  biteIds: number[];
  userIds?: number[];
  answerIds?: number[];
  next?: string;
  filter?: string;
  attributeValueIds?: number[];
  pageSize?: number;
}

export const getViewsNumber = async ({ orgId, biteIds }: { orgId: number; biteIds: string[] }) =>
  BitesApi.get(`/analytics/${orgId}/aggregated/views/`, { params: { bite_ids: JSON.stringify(biteIds) } });

export const getCommentsNumber = async ({ orgId, biteIds }: { orgId: number; biteIds: string[] }) =>
  BitesApi.get(`/analytics/${orgId}/aggregated/comments/`, { params: { bite_ids: JSON.stringify(biteIds) } });

export const getAnswersNumber = async ({ orgId, biteIds }: { orgId: number; biteIds: string[] }) =>
  BitesApi.get(`/analytics/${orgId}/aggregated/answers/`, { params: { bite_ids: JSON.stringify(biteIds) } });

export const getOverviewList = async ({ orgId, biteIds, filter, attributeValueIds, next }: IAnalyticsRequestData) =>
  BitesApi.get(`/analytics/${orgId}/overview/bite/`, {
    params: {
      bite_ids: JSON.stringify(biteIds),
      attribute_value_ids: attributeValueIds?.length ? JSON.stringify(attributeValueIds) : undefined,
      next,
      engaged: filter,
    },
  });

export const getViewsList = async ({
  orgId,
  biteIds,
  filter,
  next,
  attributeValueIds,
  pageSize,
}: IAnalyticsRequestData) =>
  BitesApi.get(`/analytics/${orgId}/views/bite/`, {
    params: {
      bite_ids: JSON.stringify(biteIds),
      attribute_value_ids: attributeValueIds?.length ? JSON.stringify(attributeValueIds) : undefined,
      next,
      viewed: filter,
      page_size: pageSize,
    },
  });

export const getAnswersList = async ({
  orgId,
  biteIds,
  userIds,
  answerIds,
  filter,
  next,
  attributeValueIds,
  pageSize,
}: IAnalyticsRequestData) =>
  BitesApi.get(`/analytics/${orgId}/answers/bite/`, {
    params: {
      bite_ids: JSON.stringify(biteIds),
      user_ids: userIds?.length ? JSON.stringify(userIds) : undefined,
      answer_ids: answerIds?.length ? JSON.stringify(answerIds) : undefined,
      attribute_value_ids: attributeValueIds?.length ? JSON.stringify(attributeValueIds) : undefined,
      next,
      answered: filter,
      page_size: pageSize,
    },
  });

export const getAnswersAggregated = async ({ orgId, biteId, attributeValueIds }) =>
  BitesApi.get(`/analytics/${orgId}/aggregated/answers/${biteId}/`, {
    params: {
      attribute_value_ids: attributeValueIds?.length ? JSON.stringify(attributeValueIds) : undefined,
    },
  });

export const getCommentsList = async ({
  orgId,
  biteIds,
  userIds,
  answerIds,
  filter,
  next,
  attributeValueIds,
  pageSize,
}: IAnalyticsRequestData) =>
  BitesApi.get(`/analytics/${orgId}/comments/bite/`, {
    params: {
      bite_ids: JSON.stringify(biteIds),
      user_ids: userIds?.length ? JSON.stringify(userIds) : undefined,
      answer_ids: answerIds?.length ? JSON.stringify(answerIds) : undefined,
      attribute_value_ids: attributeValueIds?.length ? JSON.stringify(attributeValueIds) : undefined,
      next,
      commented: filter,
      page_size: pageSize,
    },
  });
